import React from 'react';
import { Link } from 'react-router-dom';
import './navBar.css';

function NavHeader() {
    const cookiesiturl = '/cookiesitting.gif'
    return (
        <header>
            <div className='icon'>
                <img src={cookiesiturl} className="Cookie-Sitting" alt="cookie sitting"/>
                <h1>| <div className='nameMenu'>Brian the Dev</div></h1>
                <div className="NavMenu">
                    <Link to="/">Home</Link>
                    <Link to="/about">About Me</Link>
                    <Link to="/hire">Hire Me</Link>
                </div>
            </div>
            <div className='navigation'>
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Me</Link></li>
                    <li><Link to="/hire">Hire Me</Link></li>
                </ul>
            </div>
        </header>
    );
}

export default NavHeader;